import Widgets from '@/widgets'


export default [
	{name:'first_name', widget:Widgets.input, attrs: { type:"text", required:true,  placeholder:"Введите имя", },      label:"", icon: "icon-user", },
	{name:'last_name',  widget:Widgets.input, attrs: { type:"text", required:true,  placeholder:"Введите фамилию", },  label:"", icon: "icon-user", },
	{name:'patronymic', widget:Widgets.input, attrs: { type:"text", required:false, placeholder:"Введите отчество", }, label:"", icon: "icon-user", },
];
